import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { OperatorQueryKey } from '@/modules/operator/keys'
import {
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'
import { getUploadCarouselFileUrl } from '../../services'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateCarouselFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationKey: [OperatorQueryKey.GetUploadCarouselFileUrl],
		mutationFn: (params) => getUploadCarouselFileUrl(params.payload),
		...props,
	})
}
